import { FieldArray } from "formik";
import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";
import { TableNumbers } from "../../layouts/TableNumbers";
import IconDelete from "../../icons/IconDelete";
import { isArray } from "lodash";
import { guid } from "../../../util/string";
import { FieldWithLabel } from "../../form/FieldWithLabel";

export default function RevisorsHandling16(props: RevisorsSectionProps) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_handling_16 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling16">
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_16_question}
        sectionComplete={isCompleteHelpers.revisors_handling_16_complete}
        ref={refs.handling_16_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_15_ref);
        }}
      >
        {revisors_handling_16.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <div className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_16.description}
            <div className="row align-items-center">
              <label
                className="form-label col-auto"
                htmlFor={
                  revisors_handling_16
                    .revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve
                    .id
                }
              >
                {
                  revisors_handling_16
                    .revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve
                    .label
                }
              </label>
              <div className="w-auto col-auto position-relative">
                <ValidatedField
                  touched={
                    touched.revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve
                  }
                  error={
                    errors.revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve
                  }
                  autoComplete="off"
                  placeholder="0"
                  name={
                    revisors_handling_16
                      .revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve
                      .id
                  }
                  id={
                    revisors_handling_16
                      .revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve
                      .id
                  }
                />
              </div>
            </div>
          </div>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_16.revisors_handling_16_question.id}
              id={
                revisors_handling_16.revisors_handling_16_question
                  .revisors_handling_16_question_alt_1.value
              }
              value={
                revisors_handling_16.revisors_handling_16_question
                  .revisors_handling_16_question_alt_1.value
              }
              text={
                revisors_handling_16.revisors_handling_16_question
                  .revisors_handling_16_question_alt_1.label
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_16.revisors_handling_16_question.id}
              id={
                revisors_handling_16.revisors_handling_16_question
                  .revisors_handling_16_question_alt_2.value
              }
              value={
                revisors_handling_16.revisors_handling_16_question
                  .revisors_handling_16_question_alt_2.value
              }
              text={
                revisors_handling_16.revisors_handling_16_question
                  .revisors_handling_16_question_alt_2.label
              }
            >
              <label htmlFor="handling16-uddybning" className="mb-2">
                {
                  revisors_handling_16
                    .revisors_handling_16_question_alt_2_uddybning_table.label
                }
              </label>
              <FieldArray
                name={
                  revisors_handling_16
                    .revisors_handling_16_question_alt_2_uddybning_table.id
                }
                render={(arrayHelpers: any) => {
                  return (
                    <>
                      <div className="vstack gap-3 ms-n5">
                        {values.revisors_handling_16_question_alt_2_uddybning_table.map(
                          (row, index) => {
                            return (
                              <div
                                className="c-grid-card c-grid-card--col-5"
                                key={row.id ?? index}
                              >
                                <div className="d-flex align-items-center justify-content-between ps-2">
                                  <TableNumbers marginTop={0}>
                                    {(index + 1).toString()}
                                  </TableNumbers>
                                  <button
                                    className="btn btn-circle"
                                    type="button"
                                    aria-label="Fjern række"
                                    title="Fjern række"
                                    onClick={() => {
                                      arrayHelpers.remove(index);
                                    }}
                                  >
                                    <IconDelete />
                                  </button>
                                </div>
                                <div className="d-grid">
                                  <FieldWithLabel
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr`}
                                    fieldType="text"
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr
                                        .label
                                    }
                                    error={
                                      errors.revisors_handling_16_question_alt_2_uddybning_table &&
                                      isArray(
                                        errors.revisors_handling_16_question_alt_2_uddybning_table,
                                      ) &&
                                      errors
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        errors
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr
                                    }
                                    touched={
                                      touched.revisors_handling_16_question_alt_2_uddybning_table &&
                                      isArray(
                                        touched.revisors_handling_16_question_alt_2_uddybning_table,
                                      ) &&
                                      touched
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr
                                    }
                                  />
                                  <FieldWithLabel
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato`}
                                    fieldType="date"
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato
                                        .label
                                    }
                                    error={
                                      errors.revisors_handling_16_question_alt_2_uddybning_table &&
                                      isArray(
                                        errors.revisors_handling_16_question_alt_2_uddybning_table,
                                      ) &&
                                      errors
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        errors
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato
                                    }
                                    touched={
                                      touched.revisors_handling_16_question_alt_2_uddybning_table &&
                                      isArray(
                                        touched.revisors_handling_16_question_alt_2_uddybning_table,
                                      ) &&
                                      touched
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato
                                    }
                                  />
                                  <FieldWithLabel
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb`}
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb
                                        .label
                                    }
                                    placeholder="0"
                                    touched={
                                      !!(
                                        touched.revisors_handling_16_question_alt_2_uddybning_table &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ]
                                          .revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb
                                      )
                                    }
                                    error={
                                      errors &&
                                      errors.revisors_handling_16_question_alt_2_uddybning_table &&
                                      errors
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ]
                                        ? (
                                            errors
                                              .revisors_handling_16_question_alt_2_uddybning_table[
                                              index
                                            ] as any
                                          )
                                            .revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb
                                        : undefined
                                    }
                                  />
                                  <FieldWithLabel
                                    className="span-3"
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr`}
                                    fieldType="text"
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr
                                        .label
                                    }
                                    error={
                                      errors.revisors_handling_16_question_alt_2_uddybning_table &&
                                      isArray(
                                        errors.revisors_handling_16_question_alt_2_uddybning_table,
                                      ) &&
                                      errors
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        errors
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr
                                    }
                                    touched={
                                      touched.revisors_handling_16_question_alt_2_uddybning_table &&
                                      isArray(
                                        touched.revisors_handling_16_question_alt_2_uddybning_table,
                                      ) &&
                                      touched
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr
                                    }
                                  />
                                  <FieldWithLabel
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr`}
                                    fieldType="text"
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr
                                        .label
                                    }
                                    error={
                                      errors.revisors_handling_16_question_alt_2_uddybning_table &&
                                      isArray(
                                        errors.revisors_handling_16_question_alt_2_uddybning_table,
                                      ) &&
                                      errors
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        errors
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr
                                    }
                                    touched={
                                      touched.revisors_handling_16_question_alt_2_uddybning_table &&
                                      isArray(
                                        touched.revisors_handling_16_question_alt_2_uddybning_table,
                                      ) &&
                                      touched
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ] &&
                                      (
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] as any
                                      )
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr
                                    }
                                  />
                                  <FieldWithLabel
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_dato.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_dato`}
                                    fieldType="date"
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_dato
                                        .label
                                    }
                                  />
                                  <FieldWithLabel
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_beloeb.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_beloeb`}
                                    fieldType="text"
                                    placeholder="0"
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_beloeb
                                        .label
                                    }
                                    touched={
                                      !!(
                                        touched.revisors_handling_16_question_alt_2_uddybning_table &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ]
                                          .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_beloeb
                                      )
                                    }
                                    error={
                                      errors &&
                                      errors.revisors_handling_16_question_alt_2_uddybning_table &&
                                      errors
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ]
                                        ? (
                                            errors
                                              .revisors_handling_16_question_alt_2_uddybning_table[
                                              index
                                            ] as any
                                          )
                                            .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_beloeb
                                        : undefined
                                    }
                                  />
                                  <FieldWithLabel
                                    textArea
                                    className="span-3"
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse`}
                                    fieldType="text"
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse
                                        .label
                                    }
                                    touched={
                                      !!(
                                        touched.revisors_handling_16_question_alt_2_uddybning_table &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ]
                                          .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse
                                      )
                                    }
                                    error={
                                      errors &&
                                      errors.revisors_handling_16_question_alt_2_uddybning_table &&
                                      errors
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ]
                                        ? (
                                            errors
                                              .revisors_handling_16_question_alt_2_uddybning_table[
                                              index
                                            ] as any
                                          )
                                            .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse
                                        : undefined
                                    }
                                  />
                                  <FieldWithLabel
                                    className="span-2"
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr`}
                                    fieldType="text"
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr
                                        .label
                                    }
                                    touched={
                                      !!(
                                        touched.revisors_handling_16_question_alt_2_uddybning_table &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ]
                                          .revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr
                                      )
                                    }
                                    error={
                                      errors &&
                                      errors.revisors_handling_16_question_alt_2_uddybning_table &&
                                      errors
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ]
                                        ? (
                                            errors
                                              .revisors_handling_16_question_alt_2_uddybning_table[
                                              index
                                            ] as any
                                          )
                                            .revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr
                                        : undefined
                                    }
                                  />
                                  <FieldWithLabel
                                    fieldId={`${revisors_handling_16.revisors_handling_16_question_alt_2_uddybning_table.revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb.id}-${index}`}
                                    fieldName={`revisors_handling_16_question_alt_2_uddybning_table[${index}].revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb`}
                                    fieldType="text"
                                    label={
                                      revisors_handling_16
                                        .revisors_handling_16_question_alt_2_uddybning_table
                                        .revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb
                                        .label
                                    }
                                    placeholder="0"
                                    touched={
                                      !!(
                                        touched.revisors_handling_16_question_alt_2_uddybning_table &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ] &&
                                        touched
                                          .revisors_handling_16_question_alt_2_uddybning_table[
                                          index
                                        ]
                                          .revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb
                                      )
                                    }
                                    error={
                                      errors &&
                                      errors.revisors_handling_16_question_alt_2_uddybning_table &&
                                      errors
                                        .revisors_handling_16_question_alt_2_uddybning_table[
                                        index
                                      ]
                                        ? (
                                            errors
                                              .revisors_handling_16_question_alt_2_uddybning_table[
                                              index
                                            ] as any
                                          )
                                            .revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb
                                        : undefined
                                    }
                                  />
                                </div>
                              </div>
                            );
                          },
                        )}
                      </div>
                      <button
                        className="btn btn-light small mt-3 ms-n5"
                        style={{ width: "calc(100% + 2rem)" }}
                        type="button"
                        onClick={() => {
                          const newObject: (typeof values)["revisors_handling_16_question_alt_2_uddybning_table"][number] =
                            {
                              id: guid(),
                              revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb:
                                undefined,
                              revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato:
                                undefined,
                              revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr:
                                undefined,
                              revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse:
                                undefined,
                              revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr:
                                undefined,
                              revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_beloeb:
                                undefined,
                              revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr:
                                undefined,
                              revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb:
                                undefined,
                              revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr:
                                undefined,
                              revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_dato:
                                undefined,
                            };

                          arrayHelpers.push(newObject);
                        }}
                      >
                        Tilføj skema
                      </button>
                    </>
                  );
                }}
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
